'use client'

import api from "@/util/api"
import { useEffect, useMemo, useRef, useState } from "react"
import megaphone from "@/public/icon/megaphone.svg"
import SlideText from "../etc/SlideText"

export default function OneLineNotice() {
    const [list, setList] = useState<string>("")
    const aniRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)

    function fetchData() {
        api(`/api/notice/oneline/`)
            .then(res => res.json())
            .then(({ data }) => {
                setList(data?.object?.content ?? "")
            })
    }

    const cleanedHtml = useMemo(() => {
        if(typeof list !== "string") return "";
        let htmlStr: string = list;

        // case1: &amp;nbsp; → &nbsp;
        htmlStr = htmlStr.replace(/&amp;nbsp;/g, '&nbsp;');

        // case2: \xa0 → &nbsp;
        htmlStr = htmlStr.replace(/\u00A0/g, '&nbsp;');

        return htmlStr;
    }, [list]);

    useEffect(() => {
        fetchData();
    }, [])

    // useEffect(() => {
    //     if (!aniRef.current || !contentRef.current) return;

    //     const contentCurrent = contentRef.current
    //     const contentWidth = contentCurrent.offsetWidth
    //     const animateWidth = aniRef.current.clientWidth

    //     contentCurrent.style.setProperty('--content-width', `${contentWidth}px`)
    //     contentCurrent.style.setProperty('--list-width', `${animateWidth}px`)

    // }, [list])

    return (
        <div className="one-line-container">
            <div className="animation-container">
                <div><img src={megaphone.src} alt="" /></div>
                <div className="content" ref={contentRef} >
                    {/* <div ref={aniRef} dangerouslySetInnerHTML={{ __html: cleanedHtml }}></div> */}
                    <SlideText coverRef={contentRef} fontSize={14} speed={10000} betweenDivisor={2} text={cleanedHtml} autoSlide />
                </div>
            </div>
        </div>
    )
}